import classNames from 'classnames'
import styles from './Menu.module.css'
import { useTranslation } from 'react-i18next'
import Globe from '../../../assets/globe.svg?react'
import Language from '../../../assets/language.svg?react'
import Tutorial from '../../../assets/tutorial.svg?react'
import LogoMenu from '../../../assets/logo-menu.svg?react'
import ArrowBack from '../../../assets/arrow-back.svg?react'
import LoginWhite from '../../../assets/login-white.svg?react'
import Profile from '../../../assets/profile.svg?react'
import Donation from '../../../assets/donation.svg?react'
import WikiSurvey from '../../../assets/survey_white.svg?react'
import Credits from '../../../assets/credits.svg?react'
import Close from '../../../assets/close.svg?react'
import License from '../../../assets/icon-license.svg?react'
import { API_URL } from '../../../const'
import { useAuthActions, useAuthUser } from 'use-eazy-auth'
import { useLocation } from 'react-router-dom'
import { getActiveGeocontext } from '../../../utils'
import { useEffect, useMemo, useState } from 'react'
import { useTopContextState } from '../../../context/TopContext'
import { findLanguageByCode, useLingue } from '../../../hooks/languages'

export default function Menu({
  setModalLang,
  setPresentazione,
  setInfoWiki,
  setModalPaese,
  setMenu,
  setProfileOpen,
  setModalCredits,
}: {
  setModalLang: (value: boolean) => void
  setPresentazione: (value: boolean) => void
  setInfoWiki: (value: boolean) => void
  setModalPaese: (value: boolean) => void
  setMenu: (value: boolean) => void
  setProfileOpen: (value: boolean) => void
  setModalCredits: (value: boolean) => void
}) {
  const { t, i18n } = useTranslation()
  const { user } = useAuthUser()
  const username = user ? user.username.replace('mw--', ' ') : ''
  const { logout } = useAuthActions()
  const { pathname, search } = useLocation()
  const activeGeocontext = getActiveGeocontext()

  const { data: lingue, refetch: refetchLingue } = useLingue()
  useEffect(() => {
    refetchLingue()
  }, [user, refetchLingue])

  const currentLang = useMemo(() => {
    return findLanguageByCode(lingue, i18n.language)
  }, [i18n.language, lingue])

  const [coord, setCoord] = useState<{ lat: number; lon: number }>({
    lat: 0,
    lon: 0,
  })

  function success(position: any) {
    const latitude = position.coords.latitude
    const longitude = position.coords.longitude
    setCoord({ lat: latitude, lon: longitude })
  }

  function error() {
    setCoord({ lat: 0, lon: 0 })
    console.log('Unable to retrieve your location')
  }

  const { geoPermission } = useTopContextState()

  useEffect(() => {
    if (navigator.geolocation && geoPermission !== 'denied') {
      navigator.geolocation.getCurrentPosition(success, error)
    } else {
      console.log('Geolocation not supported')
    }
  }, [])

  const [showLicenseModal, setShowLicenseModal] = useState(false)

  const urlLimeSurvey = useMemo(() => {
    if (!activeGeocontext?.survey_link) return ''
    if (!username) return ''
    const url = activeGeocontext?.survey_link
    const lat = coord.lat
    const lon = coord.lon
    const lang = i18n.language
    const user = username.replace(' ', '')
    const contest = activeGeocontext?.country_code
    return `${url}?lang=${lang}&user=${user}&contest=${contest}&lat=${lat}&lon=${lon}`
  }, [activeGeocontext, i18n.language, username, coord.lat, coord.lon])

  return (
    <div className={styles.MenuContainer}>
      <div
        onClick={() => setMenu(false)}
        style={{
          width: '30%',
          background: 'rgba(0, 0, 0, 0.30)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
        }}
        className="vh-100"
      ></div>
      <div className={styles.Menu}>
        <div className="d-flex flex-column justify-content-between h-100">
          <div className="pt-2">
            <div className="mb-3">
              <ArrowBack
                className={styles.ArrowBack}
                onClick={() => setMenu(false)}
              />
            </div>
            <div className={styles.TitleMenu}>{t('GENERIC_WLM')}</div>
            <div className={styles.SloganUser}>
              {t('MENU_WELCOME_PROMPT')} {username ? `, ${username}!` : '!'}
            </div>
            <div className="mt-5">
              {username && (
                <div
                  className={styles.ListItemMenu}
                  onClick={() => {
                    setMenu(false)
                    setProfileOpen(true)
                  }}
                >
                  <Profile width={24} className="me-3" />{' '}
                  <div>
                    <div>{t('MENU_USER_PROFILE')}</div>
                    <div className={styles.ListItemOptionSelected}>
                      {username}
                    </div>
                  </div>
                </div>
              )}
              <div
                className={classNames(styles.ListItemMenu, 'mt-3')}
                onClick={() => {
                  setMenu(false)
                  setModalPaese(true)
                }}
              >
                <Globe className="me-3" />{' '}
                <div>
                  <div>{t('GENERIC_COUNTRY')}</div>
                  <div className={styles.ListItemOptionSelected}>
                    {activeGeocontext?.label}
                  </div>
                </div>
              </div>
              <div
                className={classNames(styles.ListItemMenu, 'mt-3')}
                onClick={() => {
                  setMenu(false)
                  setModalLang(true)
                }}
              >
                <Language className="me-3" />{' '}
                <div>
                  <div>{t('MENU_LANGUAGE')}</div>
                  <div className={styles.ListItemOptionSelected}>
                    {currentLang?.name}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {urlLimeSurvey && urlLimeSurvey !== '' && (
              <a
                className={styles.ListItemMenu}
                href={urlLimeSurvey}
                target="_blank"
                rel="noopener noreferrer"
              >
                <WikiSurvey width={24} className="me-3" />{' '}
                {t('MENU_REPORT_SOMETHING')}
              </a>
            )}
            {activeGeocontext?.enable_donations_text &&
              activeGeocontext.donations_link && (
                <div
                  className={classNames('mt-3', styles.ListItemMenu)}
                  onClick={() => {
                    setMenu(false)
                    window.open(activeGeocontext.donations_link, '_blank')
                  }}
                >
                  <Donation className="me-3" /> {t('MENU_DONATIONS')}
                </div>
              )}
            <div
              className={classNames('mt-3', styles.ListItemMenu)}
              onClick={() => {
                setMenu(false)
                setPresentazione(true)
              }}
            >
              <Tutorial className="me-3" /> {t('MENU_TUTORIAL')}
            </div>
            <div
              className={classNames('mt-3', styles.ListItemMenu)}
              onClick={() => {
                setMenu(false)
                setInfoWiki(true)
              }}
            >
              <LogoMenu className="me-3" /> {t('MENU_WHAT_IS_WLM')}
            </div>
            <div
              className={classNames('mt-3', styles.ListItemMenu)}
              onClick={() => {
                setMenu(false)
                setModalCredits(true)
              }}
            >
              <Credits className="me-3" /> {t('GENERIC_CREDITS')}
            </div>
            <div className="pt-4 border-top border-white">
              <div className="d-flex align-items-center justify-content-end">
                <div
                  className={styles.ListItemMenu}
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (username) {
                      logout()
                    } else {
                      setShowLicenseModal(true)
                    }
                  }}
                >
                  <LoginWhite className="me-3" />{' '}
                  {username ? t('GENERIC_LOGOUT') : t('GENERIC_LOGIN')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showLicenseModal && (
        <div
          className={styles.ResponseOverlay}
          onClick={() => {
            setShowLicenseModal(false)
          }}
        >
          <div className={styles.ResponseContainer}>
            <div
              className="position-absolute pointer"
              style={{
                top: 20,
                right: 20,
              }}
            >
              <Close />
            </div>
            <div>
              <License />
            </div>
            <div className={styles.TextBeforeLogin}>
              {t('USR_BOX_CONDITION_TITLE')}
            </div>
            <div className={styles.License}>
              <input
                checked
                className="me-2"
                type="checkbox"
                onChange={() => {}}
              />
              {t('USR_BOX_CONDITION_TEXT')}
            </div>
            <div className="w-100">
              <button
                className={styles.ButtonAccetta}
                // disabled
                onClick={() => {
                  localStorage.setItem('redirectUrl', pathname + search)
                  window.location.href = `${API_URL}/oauth/oauth-login?redirect_uri=${window.location.href}`
                }}
              >
                {t('USR_BOX_CONDITION_ACCEPT_BUTTON')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
